import React from "react";
import { Check, Loader2 } from "lucide-react";

const STEPS = [
  { id: "transcribing", label: "Transcribing" },
  { id: "scoring", label: "Scoring" },
  { id: "evidence", label: "Building evidence" },
];

/** Live pipeline stepper - reflects the REAL report stages, not a fake timer.
 *  stage: "transcribing" | "scoring" | "evidence"  */
export const ReportProgressSteps = ({ stage }) => {
  const activeIdx = STEPS.findIndex((s) => s.id === stage);
  return (
    <div data-testid="report-progress-steps" className="flex items-center gap-2 flex-wrap">
      {STEPS.map((s, i) => {
        const done = i < activeIdx;
        const active = i === activeIdx;
        return (
          <React.Fragment key={s.id}>
            {i > 0 && <span className={`h-px w-4 sm:w-6 ${done || active ? "bg-amber-500/50" : "bg-zinc-800"}`} />}
            <span
              data-testid={`report-step-${s.id}`}
              className={`inline-flex items-center gap-1.5 text-[11px] font-medium rounded-full border px-2.5 py-1 transition-colors ${
                done
                  ? "border-emerald-500/30 bg-emerald-500/[0.06] text-emerald-300"
                  : active
                    ? "border-amber-500/40 bg-amber-500/[0.08] text-amber-300"
                    : "border-zinc-800 text-zinc-600"
              }`}
            >
              {done ? (
                <Check className="h-3 w-3" />
              ) : active ? (
                <Loader2 className="h-3 w-3 animate-spin" />
              ) : (
                <span className="h-1.5 w-1.5 rounded-full bg-zinc-700" />
              )}
              {s.label}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ReportProgressSteps;
